/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFormePersonne } from './EFormePersonne';
import {
    EFormePersonneFromJSON,
    EFormePersonneFromJSONTyped,
    EFormePersonneToJSON,
} from './EFormePersonne';
import type { EOrigineSuivi } from './EOrigineSuivi';
import {
    EOrigineSuiviFromJSON,
    EOrigineSuiviFromJSONTyped,
    EOrigineSuiviToJSON,
} from './EOrigineSuivi';

/**
 * 
 * @export
 * @interface SuiviGridDto
 */
export interface SuiviGridDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idsuivi?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idservice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    service?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    centre?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    userService?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idencodeur?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    encodeur?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idrealisateurSuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    realisateurSuivi?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviGridDto
     */
    fromHope?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviGridDto
     */
    dateSuivi?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idformateur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idrepresentant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idchefEntreprise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idtuteur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idcontact?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    personne?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idtypeSuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    typeSuivi?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idsousTypeSuivi?: number;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    sousTypeSuivi?: string | null;
    /**
     * 
     * @type {EOrigineSuivi}
     * @memberof SuiviGridDto
     */
    origineSuivi?: EOrigineSuivi;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    hiddenContent?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviGridDto
     */
    actionDateEcheance?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviGridDto
     */
    actionDateRealisation?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    realisateurAction?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idcentre?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviGridDto
     */
    masquee?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SuiviGridDto
     */
    fromCrea?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    siegeSocial?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idlieuFormation?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    lieuFormation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    servicesAction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviGridDto
     */
    responsableAction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviGridDto
     */
    idsource?: number;
    /**
     * 
     * @type {EFormePersonne}
     * @memberof SuiviGridDto
     */
    forme?: EFormePersonne;
}

/**
 * Check if a given object implements the SuiviGridDto interface.
 */
export function instanceOfSuiviGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviGridDtoFromJSON(json: any): SuiviGridDto {
    return SuiviGridDtoFromJSONTyped(json, false);
}

export function SuiviGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'idservice': !exists(json, 'idservice') ? undefined : json['idservice'],
        'service': !exists(json, 'service') ? undefined : json['service'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'userService': !exists(json, 'userService') ? undefined : json['userService'],
        'idencodeur': !exists(json, 'idencodeur') ? undefined : json['idencodeur'],
        'encodeur': !exists(json, 'encodeur') ? undefined : json['encodeur'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : json['idrealisateurSuivi'],
        'realisateurSuivi': !exists(json, 'realisateurSuivi') ? undefined : json['realisateurSuivi'],
        'fromHope': !exists(json, 'fromHope') ? undefined : json['fromHope'],
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : (json['dateSuivi'] === null ? null : new Date(json['dateSuivi'])),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idrepresentant': !exists(json, 'idrepresentant') ? undefined : json['idrepresentant'],
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'personne': !exists(json, 'personne') ? undefined : json['personne'],
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : json['idtypeSuivi'],
        'typeSuivi': !exists(json, 'typeSuivi') ? undefined : json['typeSuivi'],
        'idsousTypeSuivi': !exists(json, 'idsousTypeSuivi') ? undefined : json['idsousTypeSuivi'],
        'sousTypeSuivi': !exists(json, 'sousTypeSuivi') ? undefined : json['sousTypeSuivi'],
        'origineSuivi': !exists(json, 'origineSuivi') ? undefined : EOrigineSuiviFromJSON(json['origineSuivi']),
        'hiddenContent': !exists(json, 'hiddenContent') ? undefined : json['hiddenContent'],
        'actionDateEcheance': !exists(json, 'actionDateEcheance') ? undefined : (json['actionDateEcheance'] === null ? null : new Date(json['actionDateEcheance'])),
        'actionDateRealisation': !exists(json, 'actionDateRealisation') ? undefined : (json['actionDateRealisation'] === null ? null : new Date(json['actionDateRealisation'])),
        'realisateurAction': !exists(json, 'realisateurAction') ? undefined : json['realisateurAction'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'masquee': !exists(json, 'masquee') ? undefined : json['masquee'],
        'fromCrea': !exists(json, 'fromCrea') ? undefined : json['fromCrea'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'siegeSocial': !exists(json, 'siegeSocial') ? undefined : json['siegeSocial'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'lieuFormation': !exists(json, 'lieuFormation') ? undefined : json['lieuFormation'],
        'servicesAction': !exists(json, 'servicesAction') ? undefined : json['servicesAction'],
        'responsableAction': !exists(json, 'responsableAction') ? undefined : json['responsableAction'],
        'idsource': !exists(json, 'idsource') ? undefined : json['idsource'],
        'forme': !exists(json, 'forme') ? undefined : EFormePersonneFromJSON(json['forme']),
    };
}

export function SuiviGridDtoToJSON(value?: SuiviGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuivi': value.idsuivi,
        'idservice': value.idservice,
        'service': value.service,
        'centre': value.centre,
        'userService': value.userService,
        'idencodeur': value.idencodeur,
        'encodeur': value.encodeur,
        'idrealisateurSuivi': value.idrealisateurSuivi,
        'realisateurSuivi': value.realisateurSuivi,
        'fromHope': value.fromHope,
        'dateSuivi': value.dateSuivi === undefined ? undefined : (value.dateSuivi === null ? null : value.dateSuivi.toISOString()),
        'idapprenant': value.idapprenant,
        'idformateur': value.idformateur,
        'idrepresentant': value.idrepresentant,
        'idchefEntreprise': value.idchefEntreprise,
        'idtuteur': value.idtuteur,
        'idcontact': value.idcontact,
        'personne': value.personne,
        'idtypeSuivi': value.idtypeSuivi,
        'typeSuivi': value.typeSuivi,
        'idsousTypeSuivi': value.idsousTypeSuivi,
        'sousTypeSuivi': value.sousTypeSuivi,
        'origineSuivi': EOrigineSuiviToJSON(value.origineSuivi),
        'hiddenContent': value.hiddenContent,
        'actionDateEcheance': value.actionDateEcheance === undefined ? undefined : (value.actionDateEcheance === null ? null : value.actionDateEcheance.toISOString()),
        'actionDateRealisation': value.actionDateRealisation === undefined ? undefined : (value.actionDateRealisation === null ? null : value.actionDateRealisation.toISOString()),
        'realisateurAction': value.realisateurAction,
        'idcentre': value.idcentre,
        'masquee': value.masquee,
        'fromCrea': value.fromCrea,
        'idsiegeSocial': value.idsiegeSocial,
        'siegeSocial': value.siegeSocial,
        'idlieuFormation': value.idlieuFormation,
        'lieuFormation': value.lieuFormation,
        'servicesAction': value.servicesAction,
        'responsableAction': value.responsableAction,
        'idsource': value.idsource,
        'forme': EFormePersonneToJSON(value.forme),
    };
}

